/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  string, func, number
} from 'prop-types';
import { Price } from '@thd-olt-component-react/price';
import { extend, useDataModel } from '@thd-nucleus/data-sources';
import { SuperSku } from '@thd-olt-component-react/super-sku';
import { AddTo, AddToListModel } from '@thd-olt-component-react/add-to';
import { ProductHeader } from '@thd-olt-component-react/product-details';
import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';
import { FulfillmentPodShipping, FulfillmentPodStore } from '@thd-olt-component-react/fulfillment';
import { Quantity } from '@thd-olt-component-react/quantity';
import {
  ProductPod,
  PodSticker,
  ProductATC,
  ProductRating,
  ProductSample,
  ProductIdentifier,
  ProductImage, PodFooter, PodSection, ProductCompare, ProductBadge, ProductSponsored, PodSpacer,
  ProductPodPlaceholder
} from '@thd-olt-component-react/product-pod';

export const GroupedPod = ({
  itemId,
  storeId,
  parent,
  position
}) => {

  const { data, loading } = useDataModel('product', { variables: { itemId } });
  if (!data || loading) {
    return (
      <div className="placeholder">
        <ProductPodPlaceholder podsCount={1} />
      </div>
    );
  }
  return (
    <div className="sui-w-full sui-h-full sui-grid sui-grid-cols-3">
      <div className="sui-p-0 sui-pb-2 sui-grid sui-col-span-6">
        <ProductPod
          itemId={itemId}
          hasSSKU
          analyticsData={{
            parent, position
          }}
          render={(pod) => (
            <>
              <PodSection columnAlign>
                <PodSticker position="top-right">
                  <PodSpacer padding={['TOP', 'RIGHT']}>
                    <AddTo
                      addToType="List"
                      products={[
                        {
                          itemId: pod.itemId,
                          quantity: pod.quantity
                        }
                      ]}
                      list={{ showCount: true, showIconButton: true }}
                    />
                  </PodSpacer>
                </PodSticker>
                <ProductImage
                  itemId={pod.itemId}
                  showSecondaryImage={pod.showSecondaryImage}
                />
                <ProductHeader
                  brand="below"
                  itemId={pod.itemId}
                  large={false}
                  fullWidth
                  brandTitleMaxLine={2}
                  disableShopThisCollection
                />
                <PodSpacer padding={['TOP']}>
                  <ProductRating itemId={pod.itemId} />
                </PodSpacer>
              </PodSection>
              <PodSection columnAlign>
                <SuperSku
                  itemId={pod.itemId}
                  storeId={storeId}
                  onChange={pod.onChange}
                  onHover={pod.onSSKUHover}
                  numberOfMiniSwatches={4}
                  disableMediaAndAvailability
                />

                <PodSpacer padding={['TOP']}>
                  <KeyProductFeatures
                    hideImage
                    storeId={pod.storeId}
                    itemId={pod.itemId}
                    maxfeatures={3}
                    simple
                    oneColumnGrid
                  />
                </PodSpacer>
              </PodSection>
              <PodFooter>
                <PodSpacer minHeight="60px">
                  <Price
                    itemId={pod.itemId}
                    large={false}
                    storeId={storeId}
                    displayEachUom={false}
                    onSavingsCenterToggle={pod.onSavingsCenterToggle}
                  />
                </PodSpacer>
                <div className="sui-flex">
                  <div className="sui-w-1/3">
                    <Quantity
                      itemId={pod.itemId}
                      value={1}
                      quantityLimit={pod.quantityLimit}
                      onQuantityChange={pod.onQuantityUpdate}
                    />
                  </div>
                  <div className="lg:sui-w-full sui-w-2/3">
                    <ProductATC
                      itemId={pod.itemId}
                      outline
                      checkGeneric
                      showDisabledATC
                    />
                  </div>
                </div>
              </PodFooter>
            </>
          )}
        />
      </div>
    </div>
  );
};

GroupedPod.dataModel = extend(
  ProductImage,
  Price,
  AddToListModel,
  ProductPod,
  SuperSku,
  ProductATC,
  ProductRating,
  ProductCompare,
  ProductSample,
  ProductIdentifier,
  ProductHeader,
  ProductBadge,
  ProductSponsored,
  FulfillmentPodStore,
  FulfillmentPodShipping,
  KeyProductFeatures
);

GroupedPod.propTypes = {
  itemId: string.isRequired,
  storeId: string.isRequired,
  parent: string,
  position: number,
};

GroupedPod.defaultProps = {
  parent: '',
  position: 0,
};

GroupedPod.displayName = 'GroupedPod';
